export default __webpack_public_path__ + "static/media/yeopen_main_mobile_small.db10927b.jpg";